import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    jwt: null,
    userData: null,
    tableauJs: null,
    views: []
  },
  mutations: {
    definedViews(state, views) {
      state.views = views
    },
    definedJwt(state, jwt) {
      state.jwt = jwt
    },
    definedUserData(state, user) {
      state.userData = user
    },
    logOut(state) {
      state.jwt = null
      state.userData = null
    }
  },
  getters: {
    getRoutePermited: (state) => {
      if(state.userData)
        return state.userData.permissions[0]
    },
    getJwt: (state) => {
      if(state.userData)
        return state.userData.jwt
    },
    hasPermissions: (state) => (asked) => { 
      if(state.userData) {
        const isAllowed = state.userData.permissions.find(permission => asked === permission) ? true : false
        return isAllowed
      }
    },
  },
  actions: {
  },
  modules: {
  }
})
